<template>
    <div class="hotelGoods_ui">
        <div class="container content-box">
            <div class="option" v-if="datas.showSearch == 'T'">
                <div class="option-boxs">
                    <div class="option-box" @click="isShowLayer('city')"
                        v-if="curChooseInfo.city == '' || curChooseInfo.city == 'all'">
                        <div class="option-box-top">
                            <i class="iconfont iconweizhi"></i>
                            <div class="choose" v-if="curChooseInfo.city == ''">选择地区</div>
                            <div class="choose" v-else>{{ curChooseInfo.cityDesc }}</div>
                        </div>
                        <div class="num">
                            共<b>{{ areaInfo.length - 1 }}</b>个城市
                        </div>
                    </div>
                    <div class="option-box" @click="isShowLayer('city')" v-else>
                        <div class="option-box-top">
                            <i class="iconfont iconweizhi"></i>
                            <div class="choose">{{ curChooseInfo.cityDesc }}</div>
                        </div>

                    </div>
                    <div class="option-box option-box-flex" @click="isShowLayer('hotel')" v-if="
                        curChooseInfo.hotelCode == '' || curChooseInfo.hotelCode == 'all'
                    ">
                        <div class="option-box-top">
                            <i class="iconfont iconjiudianweixuanzhong"></i>
                            <div class="choose" v-if="curChooseInfo.hotelCode == ''">
                                选择酒店
                            </div>
                            <div class="choose" v-else>{{ curChooseInfo.hotelName }}</div>
                        </div>
                        <div class="num">
                            共<b>{{ hotelList.length - 1 }}</b>个酒店
                        </div>
                    </div>
                    <div class="option-box option-box-flex" @click="isShowLayer('hotel')" v-else>
                        <div class="option-box-top">
                            <i class="iconfont iconjiudianweixuanzhong"></i>
                            <div class="choose">{{ curChooseInfo.hotelName }}</div>
                        </div>

                    </div>
                </div>

            </div>
            <div class="hotelList">
                <div class="item" v-for="(item, i) in newHotels" :key="i"
                    v-if="showAllHotel ? i >= 0 : i < datas.maxNum" @click="goLink(item.link)">
                    <div class="isLab" v-if="item.nearest">
                        <i class="iconfont iconweizhi"></i>
                        距离最近
                    </div>
                    <div class="distance">{{ item.distance_str }}</div>
                    <img class="logo" :src="item.extraLogo">
                    <div class="hotelName">
                        {{ item.descript }}
                    </div>
                    <img class="order-btn" src="https://xcx.ihotel.cn/mall/images/order-btn.png" />
                </div>

            </div>
            <div class="more-goods" v-if="hotels.length > datas.maxNum">
                <div class="btn" @click="goHotels()">
                    点击<template v-if="showAllHotel">收起</template><template v-else>查看</template>更多 <i
                        class="icongengduo1 iconfont"></i>
                </div>
            </div>
        </div>
        <div class="choose-layer" :class="{ 'choose-layer-active': isLayer.isShowCity }">
            <div class="choose-layer-box">

                <div class="tl">
                    <div class="tl-box">
                        选择地区
                        <i class="iconfont iconcha" @click="isLayer.isShowCity = false"></i>
                    </div>
                </div>
                <div class="list">
                    <div class="item" v-for="(item, i) in areaInfo" :key="i" @click="chooseCity(item)"
                        :class="{ active: curChooseInfo.city == item.code }">
                        <i class="iconfont iconweizhi"></i>{{ item.descript }}
                        <i class="iconfont icongouhao"></i>
                    </div>

                </div>
                <div class="btn" @click="closeLayer('city')">
                    <div class="btn-box">确 定</div>
                </div>
            </div>
        </div>
        <div class="choose-layer" :class="{ 'choose-layer-active': isLayer.isShowHotel }">
            <div class="choose-layer-box">
                <div class="tl">
                    <div class="tl-box">
                        选择酒店
                        <i class="iconfont iconcha" @click="isLayer.isShowHotel = false"></i>
                    </div>

                    <div class="search">
                        <div class="iconfont iconsousuo"></div>
                        <input type="text" class="search_input" v-model="hotelName" placeholder="请输入酒店名称">
                        <div class="iconfont iconyuyueshibai" v-if="hotelName" @click="clearName"></div>
                    </div>
                </div>

                <div class="list">
                    <div class="item big-item" v-for="(item, i) in newHotelList" :key="i" @click="chooseHotel(item)"
                        :class="{ active: curChooseInfo.hotelCode == item.code }">
                        <i class="iconfont iconjiudianweixuanzhong"></i>{{ item.descript }}
                        <i class="iconfont icongouhao"></i>
                    </div>
                </div>
                <div class="btn" @click="closeLayer('hotel')">
                    <div class="btn-box">确 定</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import api from "@/utils/api";
    import { setStorage, getStorage } from "@/utils/wxuser";
    import { jAlert3 } from "@/base/jAlert/jAlert";
    import { urlEncode, createUrl } from "@/utils/index";
    import { preventScroll, restoreScroll } from '@/utils/utils'
    var config = {};
    export default {
        data() {
            return {
                user: "",
                wxuser: "",
                hotelCode: 0,
                isTips: false,
                goodsDatas: {
                    hotelGroupCode: config.hotelGroupCode,
                    equipment: config.equipment,
                    appid: config.appid,
                    hotelCode: config.hotelCode,
                    firstResult: 0,
                    pageSize: 20,
                    orderCondition: "listOrder",
                    orderDirection: "desc",
                    domain: "",
                    channel: "mini_app",
                    shopChannel: "normal",
                },
                areaInfo: [],
                hotelList: [],
                curChooseInfo: {
                    city: "",
                    hotelCode: "",
                    cityDesc: "",
                    hotelName: "",
                },
                isLayer: {
                    isShowCity: false,
                    isShowHotel: false,
                },
                totalRows: 0,
                location: {},
                hotels: [],
                hotelName: "",
                showAllHotel: false,
                cityHotelCode: ''
            };
        },
        //   watch:{
        //     isLayer:{
        //       handler(val, oldVal) {
        //         if (val.isShowCity||val.isShowHotel) {
        //           preventScroll()
        //         }else{
        //           restoreScroll()
        //         }
        //       }, deep: true
        //     }
        //   },
        //   destroyed() {
        //     restoreScroll()
        //   },
        props: ["datas"],
        computed: {
            newHotels() {
                let newHotels = []

                if (this.cityHotelCode) {
                    this.hotels.forEach(item => {
                        if (item.code == this.curChooseInfo.hotelCode) {
                            newHotels.push(item)
                        }
                    })
                } else {
                    newHotels = this.hotels
                }
                return newHotels
            },
            newHotelList() {
                let hotelList = []
                if (this.hotelName) {
                    this.hotelList.forEach(item => {
                        if (item.descript.indexOf(this.hotelName) != -1) {
                            hotelList.push(item)
                        }
                    })
                } else {
                    hotelList = this.hotelList
                }
                return hotelList
            }
        },
        methods: {
            clearName() {
                this.hotelName = ''
            },
            sureEvent() {
                this.isTips = !this.isTips;
            },

            isShowLayer(val) {
                if (val == "city") {
                    this.isLayer.isShowCity = true;
                    if (this.curChooseInfo.city == "") {
                        this.curChooseInfo.city = this.areaInfo[0].code;
                        this.curChooseInfo.cityDesc = this.areaInfo[0].descript;
                    }
                }
                if (val == "hotel") {
                    if (this.curChooseInfo.city == "") {
                        jAlert3("请先选择城市");
                        return false;
                    }
                    this.isLayer.isShowHotel = true;
                    if (this.curChooseInfo.hotelCode == "") {
                        this.curChooseInfo.hotelCode = this.hotelList[0].code;
                        this.curChooseInfo.hotelName = this.hotelList[0].descript;
                    }
                }
            },
            closeLayer(val) {
                if (val == "city") {
                    this.isLayer.isShowCity = false;
                    this.findHotelByCondition(this.curChooseInfo.city);
                }
                if (val == "hotel") {
                    this.isLayer.isShowHotel = false;
                    this.getHotelList();
                }
            },
            chooseHotel(item) {
                this.curChooseInfo.hotelCode = item.code;
                this.curChooseInfo.hotelName = item.descript;
            },
            chooseCity(item) {
                this.curChooseInfo.city = item.code;
                this.curChooseInfo.cityDesc = item.descript;
            },
            rad(d) {
                return (d * Math.PI) / 180.0
            },
            getDistance(lat1, lng1, lat2, lng2) {
                var radLat1 = this.rad(lat1)
                var radLat2 = this.rad(lat2)
                var a = radLat1 - radLat2
                var b = this.rad(lng1) - this.rad(lng2)
                var s =
                    2 *
                    Math.asin(
                        Math.sqrt(
                            Math.pow(Math.sin(a / 2), 2) +
                            Math.cos(radLat1) *
                            Math.cos(radLat2) *
                            Math.pow(Math.sin(b / 2), 2)
                        )
                    )
                s = s * 6378.137 // EARTH_RADIUS;
                s = Math.round(s * 10000) / 10000 //输出为公里

                var distance = s
                var distance_str = ''

                if (parseInt(distance) >= 1) {
                    distance_str = distance.toFixed(1) + 'km'
                } else {
                    distance_str = distance * 1000 + 'm'
                }
                var distances = {
                    distance: s,
                    distance_str: distance_str
                }
                console.info('距离是', s)
                console.info('距离是', distance_str)
                return distances
            },
            getCityCode(latitude, longitude) {
                var self = this
                var city = ''
                api
                    .getCityinfo({
                        latitude: latitude,
                        longitude: longitude
                    })
                    .then((res) => {
                        if (!res) {
                            return false
                        }
                        if (typeof res !== 'object') {
                            var res = JSON.parse(res)
                        }
                        if (
                            !(
                                res &&
                                res.result &&
                                res.result.addressComponent &&
                                res.result.addressComponent.city
                            )
                        ) {
                            return false
                        }
                        city = res.result.addressComponent.city
                        var index = city.indexOf('市')
                        if (index > -1) {
                            city = city.substring(0, index)
                        }
                        if (city.indexOf('地区') > -1) {
                            var index2 = city.indexOf('地区')
                            city = city.substring(0, index2)
                        }
                        return api.findCityCodeByDes({
                            descript: city,
                            hotelGroupCode: config.hotelGroupCode
                        })
                    })
                    .then((cityInfo) => {
                        if (cityInfo.result == 1) {

                            if (!(self.cityName && self.cityCode)) {
                                let hasArea = this.areaInfo.some(item => item.code === cityInfo.retVal.resultInfo);
                                if(hasArea){
                                    this.chooseCity({
                                        code: cityInfo.retVal.resultInfo,
                                        descript: city
                                    })
                                    this.closeLayer('city')
                                }else{
                                    this.findHotelByCondition();
                                }
                               
                            }

                        } else {
                            this.findHotelByCondition();
                        }
                    })
            },
            findHotelByCondition(code) {
                var _this = this;
                var opt = {
                    hotelGroupCodes: config.hotelGroupCode,
                    otaChannel: "WECHAT",
                };
                if (code && code != "all") {
                    opt.city = code;
                }
                var reselect = false;
                if (this.curChooseInfo.hotelCode != "") {
                    reselect = true;
                }
                this.curChooseInfo.hotelCode = "";
                this.curChooseInfo.hotelName = "";
                api.findHotelByCondition(opt).then((res) => {
                    if (res.result == 1) {
                        if (res.retVal.resultCode == 0) {
                            this.hotelList = [];
                            this.hotels = [];
                            this.hotelList[0] = {
                                descript: "全部门店",
                                code: "all",
                            };
                            this.datas.items.forEach(hotel => {
                                res.retVal.resultInfos.forEach((item, i) => {
                                    if (hotel.id == item.code) {
                                        if (hotel.logo) {
                                            item.extraLogo = hotel.logo
                                        }
                                        if (hotel.link) {
                                            item.link = hotel.link
                                        }

                                        this.hotelList.push(item);
                                        this.hotels.push(item);
                                    }

                                });
                            })

                            if (reselect) {
                                this.chooseHotel(this.hotelList[0]);
                                this.closeLayer("hotel");
                            }
                        }

                        if (this.location.latitude || this.location.longitude) {
                            this.hotels.forEach((item, i) => {
                                this.$set(item, 'distance', '')
                                this.$set(item, 'distance_str', '')
                                item.distance = this.getDistance(
                                    this.location.latitude,
                                    this.location.longitude,
                                    item.hotelLatitude,
                                    item.hotelLongitude
                                ).distance
                                item.distance_str = this.getDistance(
                                    this.location.latitude,
                                    this.location.longitude,
                                    item.hotelLatitude,
                                    item.hotelLongitude
                                ).distance_str

                            })
                        }
                        if (this.hotels.length > 0) {
                            let hotels = JSON.parse(JSON.stringify(this.hotels))
                            hotels = hotels.sort((obj1, obj2) => obj1.distance - obj2.distance);

                            if (this.datas.showOrder == 'distance') {
                                hotels[0].nearest = true
                                let nearestHotels = hotels[0]
                                this.hotels = hotels
                            } else {
                                let hotelsNew = []
                                hotelsNew.push(hotels[0])
                                this.hotels.forEach(h => {
                                    if (h.code != hotels[0].code) {
                                        hotelsNew.push(h)
                                    }
                                })
                                this.hotels = hotelsNew
                            }
                        }

                    }
                });
            },
            getAreaInfo(cb) {
                var _this = this;
                var opt = {
                    hotelGroupCodes: config.hotelGroupCode,
                    otaChannel: "WECHAT",
                };

                api.findHotelByCondition(opt).then((res) => {
                    if (res.result == 1) {
                        if (res.retVal.resultCode == 0) {
                            this.hotelList = [];
                            this.hotels = [];
                            this.hotelList[0] = {
                                descript: "全部门店",
                                code: "all",
                            };
                            this.datas.items.forEach(hotel => {
                                res.retVal.resultInfos.forEach((item, i) => {
                                    if (hotel.id == item.code) {
                                        let hasArea = false
                                        this.areaInfo.forEach(area => {
                                            if (item.cityCode == area.code) {
                                                hasArea = true
                                            }
                                        })
                                        if (!hasArea) {
                                            this.areaInfo.push({
                                                code: item.cityCode,
                                                descript: item.city
                                            })
                                        }
                                    }

                                });
                            })


                        }
                        cb&&cb()

                    }
                });
            },
            goHotels() {
                this.showAllHotel ? this.showAllHotel = false : this.showAllHotel = true
                // this.goPagePolymerization('/pagesE/order/hotelListNew')
            },
            getHotelList() {
                if (this.curChooseInfo.hotelCode == 'all') {
                    this.cityHotelCode = ''
                } else {
                    this.cityHotelCode = this.curChooseInfo.hotelCode
                }

            }

        },

        created() {
            config = getStorage("config");
            this.user = getStorage("user");
            this.wxuser = getStorage("wxuser");

        },
        mounted() {

            this.areaInfo.push({
                code: "all",
                descript: "全部区域",
            });
            this.getAreaInfo(()=>{
                wx.ready(() => {
                wx.getLocation({
                    type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
                    success: (res) => {
                        this.location = res
                        this.getCityCode(this.location.latitude, this.location.longitude)

                    }, cancel: (er) => {
                        this.findHotelByCondition();
                    }, complete: (res) => {

                    }
                });
            })
            });
            


        },

    };
</script>

<style lang="less" scoped>
    @import (reference) url("~@/styles/mixin.less");

    .hotelGoods_ui {
        .content-box {
            border-bottom-left-radius: 0;
            border-bottom-right-radius: 0;
            padding: 0 0.43rem 0.53rem;
            margin-top: 0.27rem;

            .option {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-top: 0.19rem;
                padding-bottom: 0.16rem;


                .option-boxs {
                    display: flex;
                    flex: 1;

                    .option-box {
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        margin-right: 0.21rem;
                        box-sizing: border-box;
                        height: 1.25rem;
                        padding: 0.21rem 0.8rem 0.16rem 0.27rem;
                        background: fff;
                        border-radius: 0.13rem;
                        border: 0.03rem solid #ecf0f2;


                        &.option-box-flex {
                            min-width: 50%;
                            flex: 1;
                            margin: 0;
                        }

                        &.option-select {
                            border: 0;
                            flex-direction: row;
                            align-items: center;
                            justify-content: flex-start;
                            padding-left: 0.19rem;
                            position: relative;
                            padding-right: 0.4rem;
                            min-width: none;
                            color: #2f3740;
                            font-weight: bold;
                            font-size: 14px;

                            &:after {
                                content: "";
                                position: absolute;
                                right: 0;
                                top: 50%;
                                margin-top: -0.15rem;
                                height: 0.29rem;
                                width: 0.03rem;
                                background: #e7e7e7;
                            }

                            i {
                                color: #aaa;
                                margin-top: 0.03rem;
                                font-size: 13px;
                                margin-right: 0.13rem;
                            }
                        }

                        .option-box-top {
                            display: flex;
                            align-items: center;
                            color: #2f3740;
                            font-weight: bold;
                            font-size: 14px;

                            i {
                                color: #aaa;
                                margin-top: 0.03rem;
                                font-size: 12px;
                                margin-right: 0.13rem;
                            }

                            image {
                                height: 0.4rem;
                                width: 0.4rem;
                                margin-right: 0.05rem;
                            }

                            .choose {
                                position: relative;

                                &:after {
                                    content: "";
                                    position: absolute;
                                    right: -0.4rem;
                                    top: 0.08rem;
                                    border-right: 0.03rem solid #aaa;
                                    border-bottom: 0.03rem solid #aaa;
                                    width: 0.19rem;
                                    height: 0.19rem;
                                    transform: rotate(45deg);
                                }
                            }
                        }

                        .num {
                            display: flex;
                            margin-left: 0.45rem;
                            font-size: 12px;
                            line-height: 0.45rem;

                            b {
                                color: @color-theme;
                                font-weight: bold;
                                font-size: 12px;
                            }
                        }
                    }
                }

                .goods-num {
                    font-size: 11px;
                    color: #666666;
                    min-width: 1.76rem;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: flex-end;

                    p {
                        min-width: 1.76rem;
                        display: flex;
                        justify-content: flex-end;

                        b {
                            color: @color-theme;
                            font-weight: bold;
                            margin-right: 0.13rem;
                        }
                    }
                }
            }

            .hotelList {
                .item {
                    margin-top: 0.4rem;
                    position: relative;
                    height: 4.986667rem;
                    border-radius: 6px;
                    overflow: hidden;

                    &::after {
                        content: '';
                        position: absolute;
                        left: 0;
                        top: 0;
                        right: 0;
                        bottom: 0;
                        background-image: linear-gradient(180deg, rgba(0, 0, 0, 0.30) 0%, rgba(0, 0, 0, 0.30) 100%);
                        z-index: 1;
                    }

                    .logo {
                        background: rgba(0, 0, 0, 0.30);
                        border-radius: 6px;
                        width: 100%;
                        height: 4.986667rem;
                    }

                    .isLab {
                        line-height: 0.48rem;
                        left: 0.19rem;
                        top: 0.27rem;
                        position: absolute;
                        display: flex;
                        align-items: center;
                        font-size: 12px;
                        color: #FFFFFF;
                        z-index: 2;

                        .iconweizhi {
                            margin-right: 0.08rem;
                            color: #FFCF30;
                        }
                    }

                    .distance {
                        line-height: 0.48rem;
                        position: absolute;
                        right: 0.32rem;
                        top: 0.27rem;
                        font-size: 11px;
                        color: #FFFFFF;
                        z-index: 2;
                    }

                    .hotelName {
                        padding: 0 2.133333rem 0 .4rem;
                        width: 100%;
                        box-sizing: border-box;
                        font-family: PingFangSC-Medium;
                        position: absolute;

                        bottom: .48rem
                            /* 18/37.5 */
                        ;
                        font-size: 17px;
                        color: #FFFFFF;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 1;
                        overflow: hidden;
                        white-space: normal;
                        word-break: break-all;

                        z-index: 2;
                        line-height: .64rem;
                        height: .64rem;
                        font-weight: 500;
                    }

                    .order-btn {
                        position: absolute;
                        right: .133333rem;
                        bottom: .133333rem;
                        z-index: 2;
                        width: 2.56rem
                            /* 96/37.5 */
                        ;
                        height: 2.266667rem
                            /* 85/37.5 */
                        ;
                    }
                }

            }

            .more-goods {
                display: flex;
                margin-top: 0.67rem;
                justify-content: center;

                .btn {
                    border-radius: 0.43rem;
                    border: 0.03rem solid #f2f2f2;
                    display: flex;
                    height: 0.85rem;
                    padding: 0 0.56rem;
                    background: #fff;
                    justify-content: center;
                    align-items: center;
                    color: @color-theme;
                    font-size: 12px;

                    i {
                        color: @color-theme;
                        font-size: 10px;
                        margin-left: 0.11rem;
                    }
                }
            }
        }

        .choose-layer {
            position: fixed;
            width: 100%;
            height: 100%;
            z-index: 99;
            left: 0;
            top: -500%;
            opacity: 0;
            background: rgba(0, 0, 0, 0.5);
            transition: opacity 0.3s;

            &.choose-layer-active {
                opacity: 1;
                top: 0;
            }

            .choose-layer-box {
                padding: 0 0.45rem 0;
                box-sizing: border-box;
                background: rgba(249, 250, 251, 1);
                border-radius: 0.27rem;
                width: 9.15rem;
                position: absolute;
                top: 50%;
                left: 50%;

                max-height: 70%;
                overflow-y: scroll;
                transform: translate(-50%, -50%);

                .tl {
                    position: sticky;
                    top: 0;
                    padding-top: 0.21rem;
                    background: rgba(249, 250, 251, 1);
                    z-index: 9;
                    line-height: 0.8rem;

                    .tl-box {
                        font-family: PingFangSC-Medium;
                        display: flex;
                        font-size: 14px;
                        color: #333333;
                        justify-content: center;
                        font-weight: 500;
                    }


                    .iconcha {
                        position: absolute;
                        right: 0.19rem;
                        top: 0.19rem;
                        font-size: 12px;
                        color: #1E1E1E;
                    }
                }

                .search {
                    margin: 0.27rem 0.19rem 0;
                    background: #FFFFFF;
                    box-shadow: 0rem 0.16rem 0.32rem 0rem rgba(170, 170, 170, 0.06);
                    border-radius: 0.11rem;
                    padding: 0 0.53rem;
                    height: 1.17rem;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;

                    .search_input {
                        flex: 1;
                        padding: 0 0.21rem;

                    }

                    ::-webkit-input-placeholder {
                        color: #C8C9CC;
                    }

                    .iconfont {
                        color: #C8C9CC;
                    }

                    .iconsousuo {
                        font-size: 16px;
                    }

                    .iconyuyueshibai {
                        font-size: 14px;
                    }
                }

                .list {
                    display: flex;
                    min-height: 4.67rem;
                    flex-wrap: wrap;
                    padding: 0.19rem;
                    max-height: 75%;
                    background: #f9fafb;
                    align-content: flex-start;
                    justify-content: space-between;

                    .item {
                        position: relative;
                        width: 3.68rem;
                        height: 1.33rem;
                        background: rgba(255, 255, 255, 1);
                        box-shadow: 0rem 0rem 0.4rem 0rem rgba(24, 32, 111, 0.05);
                        border-radius: 0.11rem;
                        display: flex;
                        align-items: center;
                        padding-left: 0.32rem;
                        color: #111111;
                        font-weight: bold;
                        font-size: 14px;
                        margin: 0.21rem 0;
                        box-sizing: border-box;

                        &.big-item {
                            width: 100%;
                            margin: 0.11rem 0;
                        }

                        i.iconweizhi,
                        i.iconjiudianweixuanzhong {
                            color: @color-theme;
                            font-size: 12px;
                            margin-right: 0.16rem;
                        }

                        i.icongouhao {
                            display: none;
                            position: absolute;
                            top: -0.03rem;
                            right: -0.03rem;
                            width: 0.75rem;

                            align-items: center;
                            justify-content: center;
                            color: #fff;
                            font-size: 9px;
                            height: 0.53rem;
                            background: @color-theme;
                            border-top-right-radius: 0.16rem;
                            border-bottom-left-radius: 0.16rem;
                        }

                        &.active {
                            border: 0.03rem solid @color-theme;
                            box-shadow: none;

                            i.icongouhao {
                                display: flex;
                            }
                        }
                    }
                }

                .btn {
                    position: sticky;
                    bottom: 0;
                    padding-bottom: 0.64rem;
                    margin-top: 0.43rem;
                    width: 100%;

                    padding-bottom: 0.45rem;
                    background: rgba(249, 250, 251, 1);

                    .btn-box {
                        width: 100%;
                        height: 1.12rem;
                        background: @color-theme;
                        border-radius: 0.16rem;
                        height: 1.12rem;
                        display: flex;
                        justify-content: center;
                        align-items: center;

                        color: #ffffff;

                        font-size: 14px;
                    }
                }
            }
        }

    }
</style>


// WEBPACK FOOTER //
// src/components/polymerization/hotelList.vue